// Gestion du <head> par route pour une SPA (canonical, title, meta, Open Graph)

export const SITE_URL = 'https://www.umanitecanine.ca'
const DEFAULT_IMAGE = `${SITE_URL}/img/logo_with_background.png`

export interface Seo {
  title: string
  description: string
  path: string
  image?: string
}

function upsertMeta (attr: 'name' | 'property', key: string, content: string): void {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, key)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

function upsertCanonical (href: string): void {
  let el = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]')
  if (!el) {
    el = document.createElement('link')
    el.setAttribute('rel', 'canonical')
    document.head.appendChild(el)
  }
  el.setAttribute('href', href)
}

export function applySeo (seo: Seo): void {
  const url = SITE_URL + seo.path
  const image = seo.image ?? DEFAULT_IMAGE

  document.title = seo.title
  upsertMeta('name', 'description', seo.description)
  upsertMeta('property', 'og:title', seo.title)
  upsertMeta('property', 'og:description', seo.description)
  upsertMeta('property', 'og:url', url)
  upsertMeta('property', 'og:image', image)
  upsertCanonical(url)
}

export { serviceSlug } from '@/utils/slug'
